export const SESSION_CREATION_STATUS = {
	IDLE: 'idle',
	DRAINING_TRANSCRIPT: 'draining_transcript',
	CREATING_NOTE: 'creating_note',
	UPLOADING_AUDIO: 'uploading_audio',
	COMPLETED: 'completed',
	FAILED: 'failed',
}

export const SESSION_NOTE_STATUS = {
	CREATING: 'creating',
	CREATED: 'created',
	AI_PROCESSING: 'ai_processing',
	COMPLETED: 'completed',
	FAILED: 'failed',
}
